import I18n from 'I18n';
import get from 'transmute/get';
import { VISITOR } from '../../common-message-format/constants/legacySenderTypes';
import { AVATAR, DATA, EMAIL, FIRST_NAME, ID, LAST_NAME, RECIPIENT_TYPE, STATUS } from '../constants/keyPaths';
export const getAvatar = get(AVATAR);
export const getEmail = get(EMAIL);
export const getFirstName = get(FIRST_NAME);
export const getId = get(ID);
export const getLastName = get(LAST_NAME);
export const getRecipientType = get(RECIPIENT_TYPE);

/**
 * @deprecated use `conversations-async-data/async-data/operators/getters` instead
 */
export const getData = get(DATA);
/**
 * @deprecated use `conversations-async-data/async-data/operators/getters` instead
 */
export const getStatus = get(STATUS);
export const getDisplayName = recipient => {
  const firstName = getFirstName(recipient);
  const lastName = getLastName(recipient);
  const email = getEmail(recipient);
  const recipientType = getRecipientType(recipient);
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  if (firstName) {
    return firstName;
  }
  if (email) {
    return email;
  }
  if (recipientType === VISITOR) {
    return I18n.text('conversations-message-history.responder.unknownVisitorAvatar');
  }
  return null;
};
export const getNonDefaultSource = recipient => {
  const avatarSrc = getAvatar(recipient);
  return avatarSrc && !avatarSrc.includes('default') ? avatarSrc : null;
};